import { styled, Typography, useTheme } from "@mui/material";
import React from "react";
import translations from "translations";
import PLStatusPill, { PLStatusPillProps } from "components/patternLib/PLStatusPill";
import BatteryFull from "icons/components/BatteryFull";
import BatteryEmpty from "icons/components/BatteryEmpty";

const BatteryVoltageAndPillSC = styled("div")(
  () => `
    display: inline-flex;
    align-self: center;
    flex-wrap: wrap;
    flex: 1;
    margin-top: 5px;
    align-items: center;
  `
);

const BatteryIconAndPercentSC = styled("div")(
  () => `
    display: inline-flex;
    gap: 0.5rem;
    align-items: center;
  `
);

const BatteryPower: React.FC<{ batteryChargeStatus?: number | null; batteryVoltage?: string | null }> = ({
  batteryVoltage,
  batteryChargeStatus,
}) => {
  const theme = useTheme();
  const getBatteryHealthInfo = () => {
    const voltage = Number(batteryVoltage);
    return {
      label: !voltage ? translations.globals.terms.unknown : `${voltage} V`,
      type: !voltage ? "default" : voltage > 3 ? "success" : "alert",
    };
  };

  const batteryHealth = getBatteryHealthInfo();
  const batteryColor = (batteryChargeStatus ?? 0) > 5 ? theme.colors.tBlack : theme.colors.red600;
  const BatteryIcon =
    (batteryChargeStatus ?? 0) > 5 ? (
      <BatteryFull height="1.5rem" width="1.5rem" />
    ) : (
      <BatteryEmpty color={batteryColor} height="1.2rem" width="1.2rem" />
    );

  const formatBatteryPercentage = (value: number) => {
    // Check if the number has decimal places
    if (value % 1 === 0) {
      return value.toString(); // Return as integer if no decimal places
    }
    return value.toFixed(1); // Round to 1 decimal place if has decimal places
  };

  return (
    <BatteryVoltageAndPillSC>
      {batteryChargeStatus !== undefined ? (
        <BatteryIconAndPercentSC>
          {BatteryIcon}
          <Typography variant="body2" color={batteryColor}>
            {formatBatteryPercentage(batteryChargeStatus ?? 0)} %
          </Typography>
        </BatteryIconAndPercentSC>
      ) : (
        <PLStatusPill {...(batteryHealth as PLStatusPillProps)} />
      )}
    </BatteryVoltageAndPillSC>
  );
};
export default BatteryPower;
